import { BrandingModel } from 'src/models/Branding/BrandingModel';
import { httpPost } from 'src/utils/http';

const path = '/pagebranding';

/** get branding info (partner) */
export const apiGetBrandingInfo = (currentOrganizationID?: number): Promise<BrandingModel> =>
  httpPost(`${path}/getbasicbranding`, {
    currentOrganizationID,
    CurrentUrl: window.location.href,
  });
